import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';

import SettlementBadge from 'containers/SettlementRequest/components/SettlementBadge';
import { InvoiceNode, Invoices } from '../graphQL/types';

const TableContainer = styled.div`
  display: flex;
  overflow: auto;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Table = styled.table`
  width: auto !important;
  height: 40px;
  table-layout: fixed;
  white-space: nowrap;
  border-collapse: collapse;
  text-align: left;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.084px;
  color: #1b1c1e;

  border-radius: 8px;

  .title {
    th {
      padding: 16px 35px;
      background: #f7f7f8;
      font-weight: 400;
      border-top: 1px solid #eaebec;
      border-bottom: 1px solid #eaebec;
    }
  }

  .item {
    td {
      padding: 14px 35px;
      background: #fff;
      font-weight: 400;
      border-bottom: 1px solid #eaebec;
    }
  }
`;

const ShowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
  border-radius: 8px;
  background-color: #f7f7f8;

  color: #1b1c1e;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.4px;
`;

interface InvoiceTableListIProps {
  invoices: Invoices;
  handleOpenDetailModal: (invoice: InvoiceNode) => void;
}

const InvoiceTableList: React.FC<InvoiceTableListIProps> = props => {
  const { invoices, handleOpenDetailModal } = props;

  return (
    <TableContainer>
      <Table>
        <tbody>
          <tr className="title">
            <th>상태</th>
            <th>요청일</th>
            <th>진행 시작일</th>
            <th>완료일</th>
            <th>총 지급액</th>
            <th>계좌정보</th>
            <th> </th>
          </tr>
          {invoices.edges.map((invoiceItem, invoiceIdx) => {
            return (
              <tr className="item" key={invoiceIdx}>
                <td style={{ width: '52px' }}>
                  <SettlementBadge status={invoiceItem.node.status} />
                </td>
                <td style={{ width: '145px' }}>
                  {dayjs(invoiceItem.node.createdAt).format('YYYY년 MM월 DD일')}
                </td>
                <td style={{ width: '145px' }}>
                  {invoiceItem.node.startedAt !== null
                    ? dayjs(invoiceItem.node.startedAt).format(
                        'YYYY년 MM월 DD일',
                      )
                    : '-'}
                </td>
                <td style={{ width: '145px' }}>
                  {invoiceItem.node.completedAt !== null
                    ? dayjs(invoiceItem.node.completedAt).format(
                        'YYYY년 MM월 DD일',
                      )
                    : '-'}
                </td>
                <td style={{ width: '145px' }}>
                  {Number(invoiceItem.node.totalPayment.value).toLocaleString()}
                  원
                </td>
                <td style={{ width: '220px' }}>
                  {`${invoiceItem.node.bankAccount.bank.name} ${invoiceItem.node.bankAccount.accountNo} ${invoiceItem.node.bankAccount.holder}`}
                </td>
                <td style={{ width: '75px' }}>
                  <ShowButton
                    onClick={() => handleOpenDetailModal(invoiceItem.node)}
                  >
                    보기
                  </ShowButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceTableList;
